export default __webpack_public_path__ + "static/TN_Memphis_MT_0706_Vintage-car-outside-Sun-Studio_Alex-Shansky1920px-d02a5e5880b7649348c1af2523f19e3e.jpg";